/* eslint-disable react-hooks/exhaustive-deps */
import React, { ReactNode, useEffect } from "react";
import { createStructuredSelector } from 'reselect';
import {
  Route,
  Redirect,
} from "react-router-dom";
import { connect } from "react-redux";
import { selectIsAuthenticated, selectUserLocale } from "selectors/Auth";
import { RootState } from "model/state";
import { useTranslation } from "react-i18next";
import * as momentTz from 'moment-timezone';
import moment from 'moment';
import 'moment/locale/fr';
import { Dispatch } from 'redux';
import { updateAuthUserData } from 'actions';
// add more langs when required...


interface PrivateRouteProps {
  children: ReactNode;
  isAuthenticated: boolean;
  exact?: boolean;
  path?: any;
  rest?: any;
  locale?: string;
  updateAuthUserData: () => void,
}

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
const PrivateRoute = ({ children, isAuthenticated, locale, updateAuthUserData, ...rest }: PrivateRouteProps) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    updateAuthUserData();
  }, []);

  useEffect(() => {
    if (locale) {
      i18n.changeLanguage(locale);
      moment.locale(locale);
      momentTz.defineLocale(locale, (moment.localeData() as any)._config); // copy moment locale definition into moment-timezone instance
    }
  }, [locale]);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location }
            }}
          />
        )
      }
    />
  );
};

const mapStateToProps = createStructuredSelector<RootState, { isAuthenticated: boolean, locale?: string }>({
  isAuthenticated: selectIsAuthenticated(),
  locale: selectUserLocale()
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateAuthUserData: () => dispatch(updateAuthUserData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);